// Domain · RecyclingProcessChip helpers
//
// Category + tone resolution for waste-treatment process codes.
// Split out of `RecyclingProcessChip.tsx` so that module exports components only.

export type RecyclingProcessCategory = "recovery" | "disposal" | "other";

export function recyclingProcessCategory(
  code: string | null | undefined,
): RecyclingProcessCategory {
  if (!code) return "other";
  const head = code.trim().toUpperCase().charAt(0);
  if (head === "R") return "recovery";
  if (head === "D") return "disposal";
  return "other";
}

const CATEGORY_TONE: Record<RecyclingProcessCategory, "green" | "red" | "grey"> = {
  recovery: "green",
  disposal: "red",
  other:    "grey",
};

/** Resolve a process code to its canonical pill tone. Unknown / null → `"grey"`. */
export function recyclingProcessTone(code: string | null | undefined) {
  return CATEGORY_TONE[recyclingProcessCategory(code)];
}
